import React from "react";
import { useParams } from "react-router-dom";
import HotelDestinationCard from "./hotel-destination-card";
import "../css/destinations.css";
import hotelsData from "../data/hotels-data";

const Destinations = () => {
    const { category } = useParams(); // Get category from URL

    // Find the selected category from hotelsData
    const selectedCategory = hotelsData.destinations.find(dest => dest.category.toLowerCase() === category?.toLowerCase());

    return (
        <div className="destinations-section">
            <h2>{selectedCategory ? `${selectedCategory.category} Destinations` : "Destinations"}</h2>
            <div className="hotel-list">
                {selectedCategory ? (
                    selectedCategory.cities.map((city, index) => (
                        <HotelDestinationCard key={index} {...city} />
                    ))
                ) : (
                    <p>No destinations found for this category.</p>
                )}
            </div>
        </div>
    );
};

export default Destinations;
